<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <router-link
          :id="id"
          v-test="{ link: id }"
          :to="to"
          custom>
        <span
            role="link"
            :style="{ cursor: 'pointer' }"
            v-on="on">
          {{ text }}
        </span>
      </router-link>
    </template>
    <span>
      {{ tip }}
    </span>
  </v-tooltip>
</template>

<script>
  export default {
    props: {
      tip: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      to: {
        type: Object,
        default: () => {
          return {}
        }
      },
      text: {
        type: [String, Number],
        default: ''
      }
    }
  }
</script>
